import React, { useEffect } from 'react';
import { TextField } from '../../Common/Textfield';
import { ReactComponent as CrossIcon } from '../../../Assets/Images/close-circle-grey.svg';
import './DigitalStampPopup.css';
import { debounce } from '../../../utils/util';
export default function DigitalStampDenomination({
  id,
  data,
  index,
  handleRemoveItem,
  handleChange,
  setData,
  stampData,
  userDataError,
  setUserDataError
}) {
  const handleMultiply = (idVal, signal) => {
    const { denominationAmount, denominationQty } = data[idVal];
    const mulResult = parseInt(denominationAmount) * parseInt(denominationQty);
    const updatedCards = [...data];
    updatedCards[idVal].denominationValue = isNaN(mulResult) ? '' : mulResult;
    handleChange(updatedCards, signal);
    setData(updatedCards);
  };
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (stampData) handleMultiply(index, signal);
    return () => {
      controller.abort();
    };
  }, [stampData]);

  const handleInput = (value, name) => {
    setUserDataError(prevState => ({
      ...prevState,
      [name]: ''
    }));
    if (name === 'denominationAmount') {
      value = value.replace(/[^0-9]/g, '');
    }
    if (name === 'denominationQty') {
      value = value.replace(/[^0-9]/g, '');
    }
    const newData = data.map(el => {
      if (el.id === id) {
        return {
          ...el,
          [name]: parseInt(value) || ''
        };
      }
      return el;
    });
    setData(newData);
    return value;
  };
  return (
    <div key={id} className='digital-stamp-main-view'>
      {data.length > 1 && (
        <div
          className='stamp-remove-button'
          onClick={() => {
            handleRemoveItem(index);
          }}
        >
          <CrossIcon style={{ stroke: 'grey', cursor: 'pointer' }} />
        </div>
      )}
      <div className='stamp-row-direction'>
        <div>
          <div className='medium5 margin-bottom text-wrap'>Denomination Amount</div>
          <TextField
            value={stampData.denominationAmount}
            style={{ marginBottom: 20 }}
            labelClassName={'medium6'}
            placeholder={'Enter amount'}
            width={'100%'}
            removeImageLeftBorder={true}
            type={'text'}
            borderColor={'#ECF0E5'}
            name={'denominationAmount'}
            maxLength={10}
            greentick={true}
            greentickWidth={'50px'}
            textLeft={'₹'}
            required
            handleInput={handleInput}
            error={ data[index].denominationAmount.length === 0 ? userDataError.denominationAmount : ''}
          />
        </div>
        <div>
          <div className='medium5 margin-bottom qty-left-space'>Qty</div>
          <TextField
            value={stampData.denominationQty}
            style={{ marginBottom: 20 }}
            labelClassName={'medium6'}
            placeholder={'Enter Quantity'}
            width={'100%'}
            removeImageLeftBorder={true}
            type={'text'}
            borderColor={'#ECF0E5'}
            name={'denominationQty'}
            maxLength={10}
            greentick={true}
            greentickWidth={'50px'}
            required
            handleInput={handleInput}
            error={data[index].denominationQty.length === 0 ? userDataError.denominationQty : ''}
          />
        </div>
      </div>
      <div>
        <div className='medium5 margin-bottom-top'>Total Value of Denomination</div>
        <TextField
          value={stampData.denominationValue}
          style={{ marginBottom: 20 }}
          labelClassName={'medium6'}
          width={'100%'}
          removeImageLeftBorder={true}
          type={'text'}
          borderColor={'#ECF0E5'}
          name={'denominationValue'}
          maxLength={10}
          greentick={true}
          greentickWidth={'50px'}
          textLeft={'₹'}
          required
          disabled={true}
        />
      </div>
    </div>
  );
}
